// extracted by mini-css-extract-plugin
module.exports = {"container":"player-module--container--3sQoU","heading":"player-module--heading--3Tsn_","player":"player-module--player--FeE4v"};